import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Label } from '@pixacare/domain';
import { FlattenedLabel } from '@pixacare/dtos';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LabelHttpService {
  private readonly http = inject(HttpClient);

  getFlattenedLabels(): Observable<FlattenedLabel[]> {
    return this.http.get<FlattenedLabel[]>(`${environment.apiBaseUrl}/Label/Flattened`);
  }

  // Returns the user's personal labels plus their departments' label-pack labels.
  getClientLabels(): Observable<Label[]> {
    return this.http.get<Label[]>(`${environment.apiBaseUrl}/Label`);
  }

  getFlattenedLabel(labelId: number): Observable<FlattenedLabel> {
    return this.http.get<FlattenedLabel>(`${environment.apiBaseUrl}/Label/Flattened/${labelId}`);
  }

  createLabel(labels: string[]): Observable<Label[]> {
    return this.http.post<Label[]>(`${environment.apiBaseUrl}/Label`, { labels });
  }

  unsubscribeFromLabel(labelId: number, removeFromSequences: boolean): Observable<unknown> {
    return this.http.post(`${environment.apiBaseUrl}/Label/Unsubscribe`, { labelId, removeFromSequences });
  }

  createLabelPackLabels(labelPackId: number, clientCode: string, labels: string[]): Observable<Label[]> {
    return this.http.post<Label[]>(
      `${environment.apiBaseUrl}/LabelPack/${labelPackId}/Labels`,
      { labels },
      {
        params: {
          clientCode,
        },
      },
    );
  }

  deleteLabelPackLabels(labelPackId: number, clientCode: string, labels: string[]): Observable<unknown> {
    return this.http.delete(`${environment.apiBaseUrl}/LabelPack/${labelPackId}/Labels`, {
      body: {
        labels,
      },
      params: {
        clientCode,
      },
    });
  }
}
